<script>
    import {closestSelector} from "../../../commonjs/helpers";

    export default {
        name: "SimpleSection",
        data () {
            return {
                resizeListenerTimeoudId: 0,
            }
        },
    }
</script>

